// extracted by mini-css-extract-plugin
export default {"active":"productsDropdown_active__5C8vY","activeBackground":"productsDropdown_activeBackground__5p8NT"};